import { Component, OnInit } from '@angular/core';
import { observable } from 'rxjs';
import *  as $ from 'jquery';
@Component({
  selector: 'app-aspects',
  templateUrl: './aspects.component.html',
  styleUrls: ['./aspects.component.scss']
})
export class AspectsComponent implements OnInit {
  aspects = [
    {
      disposicion : "5.1",
      tipo : " Documental",
      criterio : [
        {
          descripcion : "El patrón cumple cuando presenta evidencia documental de que:",
        },{
          descripcion: "Establece, implanta y mantiene una política de prevención de riesgos psicosociales que contempla:",
        },{
          descripcion : "La promoción de un entorno organizacional favorable;",
        },{
          descripcion : "La prevención de los factores de riesgo psicosocial, y"
        },{
          descripcion: "La prevención de la violencia laboral, y",
        },{
          descripcion: "Difunde en el centro de trabajo la política de prevención de riesgos psicosociales.",
        }
      ],
      observaciones : [
        {
          descripcion: "Esta disposición entra en vigor al año posterior a su publicación en el Diario Oficial de la Federación.",
        },{
          descripcion: "La evidencia para dar cumplimiento con la difusión de la política de prevención de riesgos psicosociales puede ser a través de folletos, boletines, y/o carteles.",
        }
      ],
      riesgo: ""
    },{

      disposicion: "5.2; 7.1 a); 7.2; 7.4; 7.5; 7.6, 7.7; 7.8 y 7.9",
      tipo: "Documental o entrevista, según aplique",
      criterio : [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que"
        },{
          descripcion : "Realiza la identificación y análisis de los factores de riesgo psicosocial;"
        },{
          descripcion : "La identificación y análisis de los factores de riesgo psicosocial comprende a todos los trabajadores del centro de trabajo;"
        },{
          descripcion : "La identificación y análisis de los factores de riesgo psicosocial contempla, al menos, los factores siguientes:"
        },{
          descripcion: "Las condiciones en el ambiente de trabajo;",
        },{
          descripcion: "La falta de control sobre el trabajo;"
        },{
          descripcion: "Las cargas de trabajo;"
        },{
          descripcion: "Las jornadas de trabajo y rotación de turnos;"
        },{
          descripcion : "Interferencia en la relación trabajo-familia;"
        },{
          descripcion : "Liderazgo y relaciones negativas en el trabajo, y"
        },{
          descripcion : "La violencia laboral;"
        },{
          descripcion : "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial contiene:"
        },{
          descripcion: "Los cuestionarios que comprenden los factores enlistados en la viñeta anterior, conforme a dispuesto por el numeral 7.2 de la presente Norma;"
        },{
          descripcion: "La forma como se realiza la aplicación de los cuestionarios;",
        },{
          descripcion: "La manera de evaluar los cuestionarios, y",
        },{
          descripcion: "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y",
        },{
          descripcion: "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial están validados conforme a lo siguiente:",
        },{
          descripcion: "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;"
        },{
          descripcion : "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;"
        },{
          descripcion: "Tiene medidas de consistencia interna que presenta:"
        },{
          descripcion: "o Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y"
        },{
          descripcion: "o Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;",
        },{
          descripcion: "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes",
        },{
          descripcion: "o De ajuste absoluto con los índices:",
        },{
          descripcion: "· Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;",
        },{
          descripcion: " Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"
        },{
          descripcion: "· Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;",
        },{
          descripcion: "o De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"
        },{
          descripcion: "o De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y"
        },{
          descripcion : "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;"
        },{
          descripcion : "La identificación y análisis de los factores de riesgo psicosocial está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;"
        },{
          descripcion : "El resultado de la identificación y análisis de los factores de riesgo psicosocial consta en un informe que contiene lo siguiente:"
        },{
          descripcion : "Datos del centro de trabajo verificado:"
        },{
          descripcion : "o Nombre, denominación o razón social;"
        },{
          descripcion : "o Domicilio;"
        },{
          descripcion : "o Actividad principal;"
        },{
          descripcion: "Objetivo;"
        },{
          descripcion: "Principales actividades realizadas en el centro de trabajo"
        },{
          descripcion: "Método utilizado conforme al numeral 7.4, de la presente Norma;"
        },{
          descripcion: "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma,"
        },{
          descripcion: "Conclusiones;"
        },{
          descripcion: "Recomendaciones y acciones de intervención, en su caso, y"
        },{
          descripcion: "Datos del responsable de la evaluación;"
        },{
          descripcion: "o Nombre completo, y"
        },{
          descripcion: "o Número cédula profesional, en su caso."
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial está disponible para consulta de los trabajadores, y"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial se realiza, al menos, cada dos años."
        }
      ],
      observaciones : [
        {
          descripcion : "Entra en vigor a los dos años posteriores a su publicación en el Diario Oficial de la Federación."
        },{
          descripcion : "Este apartado del Procedimiento para la evaluación de la conformidad sólo aplica a aquellos centros de trabajo que tengan entre 16 y 50 trabajadores."
        },{
          descripcion : "Aquellos centros de trabajo que demuestren que realizan la identificación y análisis de los factores de riesgo psicosocial utilizando el método señalado en la Guía de referencia II de la presente Norma, darán cumplimiento a los numerales 7.1 a), 7.2; 7.4 y 7.5."
        },{
          descripcion : "Esta disposición (numeral 7.5) sólo aplica para aquellos centros de trabajo que desarrollen y utilicen métodos diferentes a los "+
          "contenidos en la Guía de referencia II de esta Norma"
        }
        
      ],
      riesgo : ""
      
    },{ // TERCER
      disposicion: "5.3; 7.1 b); 7.2; 7.3; 7.4; 7.5; 7.6, 7.7; 7.8 y 7.9",
      tipo: "Documental o entrevista, según aplique",
      criterio : [
        {
          descripcion : "El patrón cumple cuando presenta evidencia de que"
        },{
          descripcion: "Realiza la identificación y análisis de los factores de riesgo psicosocial;"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial comprende a todos los trabajadores del centro de trabajo;"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial contempla, al menos, los factores siguientes:"
        },{
          descripcion: "Las condiciones en el ambiente de trabajo;"
        },{
          descripcion: "Las cargas de trabajo;"
        },{
          descripcion: "La falta de control sobre el trabajo;"
        },{
          descripcion: "Las jornadas de trabajo y rotación de turnos;"
        },{
          descripcion: "Interferencia en la relación trabajo-familia;"
        },{
          descripcion: "Liderazgo y relaciones negativas en el trabajo, y"
        },{
          descripcion: "La violencia laboral;"
        },{
          descripcion: "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial contiene:"
        },{
          descripcion: "Los cuestionarios que comprenden los factores enlistados en la viñeta anterior, conforme a dispuesto por el numeral 7.2 de la presente Norma;"
        },{
          descripcion: "La forma como se realiza la aplicación de los cuestionarios;"
        },{
          descripcion: "La manera de evaluar los cuestionarios, y"
        },{
          descripcion: "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y"
        },{
          descripcion: "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial están validados conforme a lo siguiente:"
        },{
          descripcion: "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;"
        },{
          descripcion: "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;"
        },{
          descripcion: "Tiene medidas de consistencia interna que presenta:"
        },{
          descripcion: "o Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y"
        },{
          descripcion: "o Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;"
        },{
          descripcion: "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes"
        },{
          descripcion: "o De ajuste absoluto con los índices:"
        },{
          descripcion: "Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;"
        },{
          descripcion: "Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"
        },{
          descripcion: "Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;"
        },{
          descripcion: "o De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"
        },{
          descripcion: "o De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y"
        },{
          descripcion: "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;"
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial consta en un informe que contiene lo siguiente:",
        },{
          descripcion: "Datos del centro de trabajo verificado:",
        },{
          descripcion: "o Nombre, denominación o razón social;",
        },{
          descripcion: "O Domicilio",
        },{
          descripcion: "o Actividad principal;",
        },{
          descripcion: "Objetivo:",
        },{
          descripcion: "Principales actividades realizadas en el centro de trabajo; ",
        },{
          descripcion: "Método utilizado conforme al numeral 7.4, de la presente Norma;",
        },{
          descripcion: "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma",
        },{
          descripcion: "Conclusiones",
        },{
          descripcion: "Recomendaciones y acciones de intervención, en su caso, y",
        },{
          descripcion: "Datos del responsable de la evaluación;",
        },{
          descripcion: "o Nombre completo, y",
        },{
          descripcion: "o Número cédula profesional, en su caso.",
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial está disponible para consulta de los trabajadores, y",
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial se realiza, al menos, cada dos años."
        },{
          descripcion: ""
        }

      ],
      observaciones : [

      ],
      riesgo : ""
    },{// Cuarto
      disposicion: "5.3; 7.1 b); 7.2; 7.3; 7.4; 7.5; 7.6, 7.7; 7.8 y 7.9",
      tipo: "Documental o entrevista, según aplique",
      criterio : [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que:"
        },{
          descripcion: "Realiza la identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional:"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional comprende a todos los trabajadores del centro de trabajo o, se realiza a una muestra representativa conforme a lo señalado en la en el numeral III. 1 de la Guía de referencia III de esta Norma;"
        },{
          descripcion: "La identificación de los factores de riesgo psicosocial y análisis contempla los factores siguientes:"
        },{
          descripcion: "Las condiciones en el ambiente de trabajo;"
        },{
          descripcion: "Las cargas de trabajo;"
        },{
          descripcion: "La falta de control sobre el trabajo;"
        },{
          descripcion: "Las jornadas de trabajo y rotación de turnos;"
        },{
          descripcion: "Interferencia en la relación trabajo-familia;"
        },{
          descripcion: "Liderazgo y relaciones negativas en el trabajo, y"
        },{
          descripcion: "La violencia laboral;"
        },{
          descripcion: "La evaluación del entorno organizacional favorable comprende:"
        },{
          descripcion: "El sentido de pertenencia de los trabajadores a la empresa"
        },{
          descripcion: "La formación para la adecuada realización de las tareas encomendadas;"
        },{
          descripcion: "La definición precisa de responsabilidades para los trabajadores;"
        },{
          descripcion: "La participación proactiva y comunicación entre el patrón, sus representantes y los trabajadores;"
        },{
          descripcion: "La distribución adecuada de cargas de trabajo, con jornadas laborales regulares, y"
        },{
          descripcion: "La evaluación y el reconocimiento del desempeño;"
        },{
          descripcion: "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial, así como para la evaluación del entorno organizacional contempla"
        },{
          descripcion: "Los cuestionarios comprenden los factores enlistados en las dos viñetas inmediatas anteriores, conforme a dispuesto por los numerales 7.2 y 7.3 de esta Norma;"
        },{
          descripcion: "La forma como se realiza la aplicación de los cuestionarios;"
        },{
          descripcion: "La manera de evaluar los cuestionarios, y"
        },{
          descripcion: "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y"
        },{
          descripcion: "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional están validados conforme a lo siguiente:"
        },{
          descripcion: "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;"
        },{
          descripcion : "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;"
        },{
          descripcion : "Tiene medidas de consistencia interna que presenta:"
        },{
          descripcion : "o Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y"
        },{
          descripcion : "o Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;"
        },{
          descripcion : "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes:"
        },{
          descripcion : "o De ajuste absoluto con los índices:"
        },{
          descripcion : " Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;"
        },{
          descripcion : " Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"
        },{
          descripcion : " Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;"
        },{
          descripcion : "o De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"
        },{
          descripcion : "o De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y"
        },{
          descripcion : "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;"
        },{
          descripcion : "La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;"
        },{
          descripcion : "El resultado de la identificación y análisis de los factores de riesgo psicosocial, así como de la evaluación del entorno organizacional consta en un informe que contiene lo siguiente:"
        },{
          descripcion: "Datos del centro de trabajo verificado:"
        },{
          descripcion: "o Nombre, denominación o razón social;"
        },{
          descripcion: "o Domicilio;"
        },{
          descripcion: "o Actividad principal;"
        },{
          descripcion: "Objetivo"
        },{
          descripcion: "Principales actividades realizadas en el centro de trabajo;"
        },{
          descripcion: "Método utilizado conforme al numeral 7.4, de la presente Norma;"
        },{
          descripcion: "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma,"
        },{
          descripcion: "Concluciones"
        },{
          descripcion: "Recomendaciones y acciones de intervención, en su caso, y"
        },{
          descripcion: "Datos del responsable de la evaluación;"
        },{
          descripcion: "o Nombre completo, y"
        },{
          descripcion: "o Número cédula profesional, en su caso."
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial está disponible para consulta de los trabajadores, y"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial se realiza, al menos, cada dos años."
        }
      ],
      observaciones : [

      ]
    },{
      disposicion: "5.4, 8.1 y 8.2",
      tipo :"", 
      criterio : [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que:"
        },{
          descripcion: "Realiza la identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional:"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional comprende a todos los trabajadores del centro de trabajo o, se realiza a una muestra representativa conforme a lo señalado en la en el numeral III. 1 de la Guía de referencia III de esta Norma;"
        },{
          descripcion: "La identificación de los factores de riesgo psicosocial y análisis contempla los factores siguientes:"
        },{
          descripcion: "Las condiciones en el ambiente de trabajo"
        },{
          descripcion: "Las cargas de trabajo;"
        },{
          descripcion: "La falta de control sobre el trabajo"
        },{
          descripcion: "Las jornadas de trabajo y rotación de turnos"
        },{
          descripcion: "Interferencia en la relación trabajo-familia;"
        },{
          descripcion: "Liderazgo y relaciones negativas en el trabajo, y"
        },{
          descripcion: "La violencia laboral;"
        },{
          descripcion : "La evaluación del entorno organizacional favorable comprende:"
        },{
          descripcion : "El sentido de pertenencia de los trabajadores a la empresa;"
        },{
          descripcion : "La formación para la adecuada realización de las tareas encomendadas"
        },{
          descripcion : "La definición precisa de responsabilidades para los trabajadores;"
        },{
          descripcion : "La participación proactiva y comunicación entre el patrón, sus representantes y los trabajadores"
        },{
          descripcion : "La distribución adecuada de cargas de trabajo, con jornadas laborales regulares, y"
        },{
          descripcion : "La evaluación y el reconocimiento del desempeño"
        },{
          descripcion : "El método que se utiliza para realizar la identificación y análisis de los factores de riesgo psicosocial, así como para la evaluación del entorno organizacional contempla"
        },{
          descripcion : "Los cuestionarios comprenden los factores enlistados en las dos viñetas inmediatas anteriores, conforme a dispuesto por los numerales 7.2 y 7.3 de esta Norma;"
        },{
          descripcion : "La forma como se realiza la aplicación de los cuestionarios;"
        },{
          descripcion : "La manera de evaluar los cuestionarios, y"
        },{
          descripcion : "Los niveles y la forma de determinar el riesgo conforme a los resultados de los cuestionarios aplicados, y"
        },{
          descripcion : "Los cuestionarios que utiliza el centro de trabajo para la identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional están validados conforme a lo siguiente:"
        },{
          descripcion: "La validación fue realizada en trabajadores cuyos centros de trabajo se ubican en el territorio nacional;",
        },{
          descripcion: "El número de individuos que se utilizó para realizar la validación sea mayor o igual a 10 veces por cada reactivo contemplado inicialmente;",
        },{
          descripcion : "Tiene medidas de consistencia interna que presenta:",
        },{
          descripcion : "o Coeficientes de confiabilidad (alfa de Cronbach) superiores a 0.7; y",
        },{
          descripcion : "o Coeficientes de correlación (Pearson o Spearman), con r mayor a 0.5, y un nivel de significancia mayor o igual a 0.05;",
        },{
          descripcion : "Tiene validez de constructo mediante análisis factorial confirmatorio cumpliendo con medidas e índices de ajuste siguientes:",
        },{
          descripcion : "o De ajuste absoluto con los índices:",
        },{
          descripcion: " Índice de Bondad de Ajuste, GFI (Goodness of Fit Index), mayor a 0.90;",
        },{
          descripcion: " Residuo cuadrático medio, RMSR (Root Mean Square Residual), cercana a 0 y máximo 0.08, y"
        },{
          descripcion: " Error de aproximación cuadrático medio, RMSEA (Root Mean Square Error of Approximation), menor a 0.08;"
        },{
          descripcion: "o De ajuste incremental o relativo con el índice de ajuste normado, NFI (Normed Fit Index), mayor a 0.90, y"
        },{
          descripcion: "o De parsimonia con el índice Ji cuadrada normada: X2/gl menor o igual a 5, y"
        },{
          descripcion: "Se aplican en población trabajadora de características semejantes a la población trabajadora en que se validó;"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional está integrada al diagnóstico de seguridad y salud en el trabajo a que se refiere la NOM-030-STPS-2009, vigente o las que la sustituyan;"
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial, así como de la evaluación del entorno organizacional consta en un informe que contiene lo siguiente:"
        },{
          descripcion: "Datos del centro de trabajo verificado:"
        },{
          descripcion: "o Nombre, denominación o razón social;"
        },{
          descripcion: "Domicilio"
        },{
          descripcion: " Actividad principal;"
        },{
          descripcion: "Objetivo"
        },{
          descripcion: "Principales actividades realizadas en el centro de trabajo;"
        },{
          descripcion: "Método utilizado conforme al numeral 7.4, de la presente Norma;"
        },{
          descripcion: "Resultados obtenidos de acuerdo con el numeral 7.4, inciso d) de esta Norma,"
        },{
          descripcion: "conclusiones"
        },{
          descripcion: "Recomendaciones y acciones de intervención, en su caso, y"
        },{
          descripcion: "Datos del responsable de la evaluación"
        },{
          descripcion: "o Nombre completo, y"
        },{
          descripcion: "o Número cédula profesional, en su caso."
        },{
          descripcion: "El resultado de la identificación y análisis de los factores de riesgo psicosocial, así como de la evaluación del entorno organizacional está disponible para consulta de los trabajadores, y"
        },{
          descripcion: "La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional se realiza, al menos, cada dos años."
        }
      ],
      observaciones : [

      ],
    },{
      disposicion: "5.5",
      tipo :"Documental", 
      criterio : [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que:"
        },{
          descripcion: "Entra en vigor al año posterior a su publicación en el Diario Oficial de la Federación."
        },{
          descripcion: "Identifica a los trabajadores que fueron sujetos a acontecimientos traumáticos severos durante o con motivo del trabajo y,"
        },{
          descripcion: " Canaliza a los trabajadores identificados para su atención, a la institución de seguridad social o privada, o con el médico del centro de trabajo o de la empresa."
        },
      ],
      observaciones: [
        {
          descripcion: "Entra en vigor al año posterior a su publicación en el Diario Oficial de la Federación."
        },
      ]
    },{
      disposicion: "5.6",
      tipo :"Documental", 
      criterio : [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que practica exámenes médicos y evaluaciones psicológicas al trabajador o a los trabajadores expuestos a violencia laboral y a los factores de riesgo psicosocial, cuando existan signos o síntomas que denoten alteración a su salud y el resultado de la identificación y análisis de los factores de riesgo psicosocial y/o existan quejas de violencia laboral."
        },
      ],
      observaciones: [
        {
          descripcion: "Los exámenes médicos y evaluaciones psicológicas podrán efectuarse a través de la institución de seguridad social o privada, médico, psiquiatra o psicólogo del centro de trabajo, según corresponda, y deberán efectuarse de conformidad con lo establecido por las normas oficiales mexicanas que al respecto emitan la Secretaría de Salud y/o la Secretaría del Trabajo y Previsión Social, y a falta de éstas, los que indique la institución de seguridad social o privada, o el médico del centro de trabajo, que le preste el servicio médico."+

          "Entra en vigor a los dos años posteriores a su publicación en el Diario Oficial de la Federación",
        }

      ]
    },{
      descripcion: "5.7",
      tipo: "Documental",
      criterio: [
        {
          descripcion: "El patrón cumple cuando presenta evidencia de que difunde y proporciona información a los trabajadores sobre:"
        },{
          descripcion: "La política de prevención de riesgos psicosociales;"
        },{
          descripcion: "Las medidas adoptadas para combatir las prácticas opuestas al entorno organizacional favorable y actos de violencia laboral;",
        },{
          descripcion:  "Las medidas y acciones de prevención y, en su caso, las acciones de control de los factores de riesgo psicosocial;",
        },
        {
          descripcion:  "Los mecanismos para presentar quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral;",
        },{
          descripcion:  "Los resultados de la identificación y análisis de los factores de riesgo psicosocial para los centros de trabajo que tengan entre 16 y 50 trabajadores, y de la identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional tratándose de centros de trabajo de más de 50 trabajadores, y",
        },{
          descripcion:  "Las posibles alteraciones a la salud por la exposición a los factores de riesgo psicosocial.",
        },
          
        
      ],
      observaciones: [
        {
          descripcion: "La evidencia para dar cumplimiento con proporcionar y difundir información puede ser a través de folletos, boletines, y/o carteles."+
          "Esta disposición entra en vigor al año posterior a su publicación en el Diario Oficial de la Federació"
        }
      ]
    },{
      descripcion: "5.8",
      tipo: "Documental",
      criterio: [
        {
          descripcion: "Los resultados de la identificación y análisis de los factores de riesgo psicosocial y, además, tratándose de centros de trabajo de más de 50 trabajadores, de las evaluaciones del entorno organizacional",
        },{
          descripcion: "Las medidas de control adoptadas cuando el resultado de la identificación y análisis de los factores de riesgo psicosocial y evaluación del entorno organizacional lo señale, y"
        },{
          descripcion: "",
        },{
          descripcion: "Los nombres de los trabajadores a los que se les practicaron los exámenes o evaluaciones clínicas y que se comprobó la exposición a factores de riesgo psicosocial, a actos de violencia laboral o acontecimientos traumáticos severos."
        }
      ]
    }
  ]

  constructor() { }

  ngOnInit() {
    $(window).scrollTop();
  }

}
